import { StyleProp, TextStyle, ViewStyle } from 'react-native';
import { AdvertCategory } from '../../types';
import { Advertisement } from '../../../api/adserver';

export interface Props {
  placeholder?: string;
  style?: StyleProp<TextStyle>;
  containerStyle?: StyleProp<ViewStyle>;
  inputContainerStyle?: StyleProp<ViewStyle>;
  enableBack?: boolean;
  initialValue?: string;
  onBackPressed?: () => void;
  onSearchSubmit?: (value: string) => void;
  onInputUpdate?: (value: string) => void;
  isRendering?: (value: boolean) => void;
  resultsList?: SearchResultCollection;
  onResultPress?: (item: SearchResult) => void;
  sourceCategories?: AdvertCategory[];
  sourceAdvertsList?: Advertisement[];
  onHasResults?: (hasResults: boolean) => void;
}

export enum SearchItemType {
  category = 'category',
  advert = 'advert',
  divider = 'divider',
  noMatches = 'noMatches',
}

export type SearchResult = {
  id: string;
  title: string;
  itemType: SearchItemType;
  subTitle?: string;
};

export type SearchResultCollection = {
  categories: SearchResult[];
  adverts: SearchResult[];
  noMatches: boolean; // there was a search, but there were not matches
};
